import {
    Grid,
    Avatar,
    Box,
    Button,
    Dialog,
    Slide,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TextField,
    Tab,
    touchRippleClasses,
    Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import pr from "../lib/pr";
import axios from "axios";
import { loginState, configState } from "../lib/State";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import { ReactComponent as DiscountIcon } from '../assets/discount_back.svg';
import { ReactComponent as BirthdayBackIcon } from '../assets/discount_birth.svg';

function MypageLoggedCouponDiscount(props) { // 내 쿠폰 > 할인쿠폰
    const { login } = props;
    const cid = get_cid();
    const [rows, setRows] = useState([]);
    const history = useHistory();
    const token = get_token();
    const onGoBookClick = (event) => {
        history.push("/book?coupon_seq=" + event.target.value);
    };
    const load_data = async () => {
        let result = await axios.post(configState.api+"/gympass/my_coupon_discount", {
            token: token,
            cid: cid,
            mcd: login.mcd,
            level: login.level,
        });        
        setRows(result.data.rows);
    };
    useEffect(() => {
        load_data();
    }, []);
    return (
        <>
            {
                // 쿠폰이 없을 때
                rows.length === 0 && (
                    <>
                        <Box sx={{ width: "100%", textAlign: "center", fontSize:14 }}>
                            사용 가능한 쿠폰이 없습니다.
                        </Box>
                    </>
                )
            }

            <>
                {/* 쿠폰이 있을 때 */}
                {rows.map((item, index) => {
                    console.log(item.expire)
                    const remain_count =
                        item.can_use
                    const use_amount = item.use_amount;
                    let is_available = false;
                    const today = moment().format("YYYY.MM.DD");
                    const enroll_sdate = item.sdate; // 시작일
                    const enroll_edate = moment(item.edate).format(
                        "YYYY.MM.DD"
                    ); // 만료일

                    return (
                        <Grid
                            container
                            display="flex"
                            width="100%"
                            justifyContent="center"
                            alignItems="center"
                            key={index}
                            // sx={{
                            //     marginBottom: '10px'
                            // }}
                        >
                            <Box
                                sx={{
                                    width: '90%',
                                    position: 'relative',
                                }}>
                                
                                { item.dcoupon_seq === 9 ? <img src="/img/coupon/birth.png" width='100%' /> :
                                <DiscountIcon width='100%' /> }

                                <Box
                                    sx={{
                                        position: 'absolute',
                                        left: '30%',
                                        top: '45%',
                                        transform: 'translateY(-45%)',
                                        marginLeft: '10px',
                                        color: `${item.dcoupon_seq===9?"black":"white"}`,
                                    }}>
                                    <Box
                                        sx={{
                                            fontSize: '13px',
                                            marginRight: '10px',
                                            fontWeight: 'bold',
                                            letterSpacing: '-1px',
                                        }}>
                                        <Box>
                                            {item.name}
                                        </Box>
                                        <Box>
                                            {enroll_edate} 만료예정
                                        </Box>
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        right: '10%',
                                        top: '45%',
                                        transform: 'translateY(-45%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontWeight: 'bold',
                                        marginLeft: '8px',
                                        color: 'white'
                                    }}>
                                    {item.gubun === '할인율' &&
                                    <>
                                    <Box
                                        sx={{
                                            fontSize: '20px',
                                            color: `${item.dcoupon_seq===9?"black":"white"}`,
                                        }}>
                                        {item.rate}
                                    </Box>
                                    <Box
                                        sx={{
                                            color: `${item.dcoupon_seq===9?"black":"white"}`,
                                            fontSize: '13px'
                                        }}>
                                        %
                                    </Box>
                                    </>
                                    }
                                    {item.gubun === '금액' &&
                                    <>
                                    <Box
                                        sx={{
                                            fontSize: '20px',
                                        }}>
                                        {item.amount}
                                    </Box>
                                    <Box
                                        sx={{
                                            fontSize: '13px'
                                        }}>
                                        원
                                    </Box>
                                    </>
                                    }
                                </Box>
                            </Box>                            
                        </Grid>
                    );
                })}
                <Box sx={{ width: '100%', height: '80px'}}></Box>
            </>
        </>
    )
};

export default MypageLoggedCouponDiscount;